export const ABWASSERBEHANDLUNG = "ABWASSERBEHANDLUNG";
export const KUEHLWASSER = "KUEHLWASSER";
export const ENTLASTUNG = "ENTLASTUNG";
export const KANALNETZ = "KANALNETZ";

export function anlagentypIdToObj(id) {
    switch (id) {
        case ABWASSERBEHANDLUNG:
            return { id: ABWASSERBEHANDLUNG, value: "Abwasserbehandlung" };
        case KUEHLWASSER:
            return { id: KUEHLWASSER, value: "Kühlwasser" };
        case ENTLASTUNG:
            return { id: ENTLASTUNG, value: "Entlastung" };
        case KANALNETZ:
            return { id: KANALNETZ, value: "Kanalnetz" };
        default:
            return null;
    }
}
